var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 30,
  fill: "currentColor",
  viewBox: "0 0 40 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 13.523s4.246-2.668 5.627-3.162c.596 1.084 5.032 8.194 5.723 9.867C13.524 18.156 27.34 2.662 39.772 0c-1.084 1.775-1.774 2.566-1.774 2.566S16.585 16.382 13.524 30H9.377S4.836 19.835 0 13.523",
  clipRule: "evenodd"
})));
export default SvgCheck;